// Load more pagination for product page
document.addEventListener('DOMContentLoaded', function() {
  var loadMoreButton = document.getElementById('load-more');
  var productGrid = document.getElementById('product-grid');
  var progressBar = document.querySelector('.progress-item');
  var currentPage = 1;
  var isLoading = false;
  var totalProducts = parseInt(document.getElementById('total_count').textContent, 10); // Get total pages from the element
  var productsPerPage = parseInt(document.getElementById('productsPerPage').textContent, 10); // Products per page
  var currentProductsElement = document.getElementById('currentProducts'); // Element to show current products count

  var currentProductsLoaded = parseInt(document.getElementById('currentProducts').textContent, 10);
  //console.log(currentProductsLoaded);
  // Calculate total number of pages
  var totalPages = Math.ceil(totalProducts / productsPerPage);
  var pagesLoaded = 1; // Initially loaded pages count
  // console.log(productsPerPage);
  // console.log(totalProducts);
  //  console.log(totalPages);
  loadMoreButton.addEventListener('click', function() {
    if (isLoading) return;

    isLoading = true;
    loadMoreButton.innerText = 'Loading...';

    currentPage++;

    var nextPageUrl = window.location.pathname + '?page=' + currentPage + '&section_id=dev-main-collection-product-grid';

    fetch(nextPageUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Error loading page: ' + response.status);
        }
        return response.text();
      })
      .then(data => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');

        var newProducts = doc.querySelectorAll('#product-grid > li');

        newProducts.forEach(product => {
          productGrid.appendChild(product);
        });

        // Update the count of loaded products
        currentProductsLoaded += newProducts.length;
        currentProductsElement.textContent = currentProductsLoaded; // Update the text for current products

        

        pagesLoaded++; // Increment pages loaded count

        if (currentPage >= totalPages) {
          loadMoreButton.style.display = 'none';
        } else {
          loadMoreButton.innerText = 'Load More';
        }

        // Update progress bar width based on pages loaded
        var progressBarWidth = (pagesLoaded / totalPages) * 100;
        progressBar.style.width = progressBarWidth + '%';

        isLoading = false;
      })
      .catch(error => {
        console.error('Error loading more products:', error);
        isLoading = false;
        loadMoreButton.innerText = 'Load More';
      });
  });
});


// Product layout switching
document.addEventListener('DOMContentLoaded', function () {
  const gridButton = document.getElementById('grid-view');
  const listButton = document.getElementById('list-view');
  const productGrid = document.querySelector('.product-grid');

  if (gridButton && listButton && productGrid) {
    gridButton.addEventListener('click', function () {
      productGrid.classList.remove('list-view');
      gridButton.classList.add('active');
      listButton.classList.remove('active');
    });

    listButton.addEventListener('click', function () {
      productGrid.classList.add('list-view');
      listButton.classList.add('active');
      gridButton.classList.remove('active');
    });
  }
});
